function getUrlFormatSlugs(urlFormat) {
  if (!urlFormat) return [];

  return urlFormat
    .split('}}')
    .map(part => part.split('{{')[1])
    .filter(part => part);
}

module.exports = getUrlFormatSlugs;
